export const INVESTOR_DECK = {
  pdf: '/assets/investor-deck.pdf?v=10-slide-v2',
  pptx: '/assets/investor-deck.pptx?v=10-slide-v2',
  manifest: '/assets/investor-deck.json',
  pdfFilename: 'ProactiveUMS-Investor-Deck.pdf',
  pptxFilename: 'ProactiveUMS-Investor-Deck.pptx',
};
